/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const CSS = {
  container: "container",
  containerNone: "container--none-selection",
  icon: "icon",
  iconEnd: "icon--end",
  iconStart: "icon--start",
  itemContent: "content",
  link: "link"
};
const ICONS = {
  check: "check"
};
export {
  CSS as C,
  ICONS as I
};
